module.exports = __webpack_public_path__ + "img/vibrationbox.9a23a1e4.png";